// Set the connect feature options
export const connectedFeatureOptions: { name: string, value: string }[] = [
    {
        name: 'email.email_template.connected_feature.proposals',
        value: 'proposals'
    },
    {
        name: 'email.email_template.connected_feature.orders',
        value: 'orders'
    },
    {
        name: 'email.email_template.connected_feature.jobs',
        value: 'jobs'
    },
    {
        name: 'email.email_template.connected_feature.appointments',
        value: 'appointments'
    },
    {
        name: 'email.email_template.connected_feature.invoices',
        value: 'invoices'
    },
    {
        name: 'email.email_template.connected_feature.tickets',
        value: 'tickets'
    },
    {
        name: 'email.email_template.connected_feature.contacts',
        value: 'contacts'
    },
];

// Set the send to options
export const sendToOptionsMap: Record<string, { name: string, value: string }[]> = {
    proposals: [
        { name: 'email.email_template.send_to.client', value: 'client' },
        // { name: 'email.email_template.send_to.user_group', value: 'user_group' },
        { name: 'email.email_template.send_to.specific_email', value: 'specific_email' }
    ],
    orders: [
        { name: 'email.email_template.send_to.client', value: 'client' },
        // { name: 'email.email_template.send_to.user_group', value: 'user_group' },
        { name: 'email.email_template.send_to.specific_email', value: 'specific_email' }
    ],
    jobs: [
        { name: 'email.email_template.send_to.client', value: 'client_company' }, // (Zakelijke) opdrachtgever
        { name: 'email.email_template.send_to.location_person', value: 'location_person' },  // Klant werkadres
        // { name: 'email.email_template.send_to.user_group', value: 'user_group' },
        { name: 'email.email_template.send_to.specific_email', value: 'specific_email' }
    ],
    appointments: [
        { name: 'email.email_template.send_to.client', value: 'client_company' }, // (Zakelijke) opdrachtgever
        { name: 'email.email_template.send_to.location_person', value: 'location_person' },  // Klant werkadres
        // { name: 'email.email_template.send_to.user_group', value: 'user_group' },
        { name: 'email.email_template.send_to.specific_email', value: 'specific_email' }
    ],
    invoices: [
        { name: 'email.email_template.send_to.client', value: 'client' },
        { name: 'email.email_template.send_to.client_invoice_address', value: 'client_invoice_address' },
        // { name: 'email.email_template.send_to.user_group', value: 'user_group' },
        { name: 'email.email_template.send_to.specific_email', value: 'specific_email' }
    ],
    tickets: [
        { name: 'email.email_template.send_to.requester', value: 'requester' },
    ],
    contacts: [
        { name: 'email.email_template.send_to.contact', value: 'contact' },
        { name: 'email.email_template.send_to.specific_email', value: 'specific_email' }
    ],
};

// Set the trigger status options, contact templates are only sent manually
export const triggerStatusOptionsMap: Record<string, { name: string, value: string }[]> = {
    contacts: [],
    tickets: [
        { name: 'ticket.status.new', value: 'new' },
    ],
    proposals: [
        { name: 'proposal.status.draft', value: 'draft' },
        { name: 'proposal.status.sent', value: 'sent' },
        { name: 'proposal.status.expired', value: 'expired' },
        { name: 'proposal.status.accepted', value: 'accepted' },
        { name: 'proposal.status.rejected', value: 'rejected' },
    ],
    orders: [
        { name: 'order.status_condition.order_created', value: 'order_created' },
    ],
    jobs: [
        { name: 'job.status_condition.job_created', value: 'job_created' },
        { name: 'job.status_condition.to_schedule', value: 'to_schedule' },
        { name: 'job.status_condition.one_reserved_appointment', value: 'one_reserved_appointment' },
        { name: 'job.status_condition.one_scheduled_appointment', value: 'one_scheduled_appointment' },
        { name: 'job.status_condition.running_travel_timer', value: 'running_travel_timer' },
        { name: 'job.status_condition.running_work_timer', value: 'running_work_timer' },
        { name: 'job.status_condition.incomplete', value: 'incomplete' },
        { name: 'job.status_condition.completed', value: 'completed' },
        { name: 'job.status_condition.finished', value: 'finished' },
    ],
    appointments: [
        { name: 'appointment.status.to_be_assigned', value: 'to_be_assigned' },
        { name: 'appointment.status.reserved', value: 'reserved' },
        { name: 'appointment.status.scheduled', value: 'scheduled' },
        { name: 'appointment.status.done', value: 'done' },
    ],
    invoices: [
        { name: 'invoice.status.draft', value: 'draft' },
        { name: 'invoice.status.open', value: 'open' },
        { name: 'invoice.status.overdue', value: 'overdue' },
        { name: 'invoice.status.reminded', value: 'reminded' },
        { name: 'invoice.status.paid', value: 'paid' },
    ],
};

// Set the trigger timing options
export const triggerTimingOptions: { name: string, value: string }[] = [
    { name: 'email.email_template.trigger_timing.immediate', value: 'immediate' },
    { name: 'email.email_template.trigger_timing.before', value: 'before' },
    { name: 'email.email_template.trigger_timing.delay', value: 'delay' },
];

// Set the trigger offset unit options
export const triggerOffsetUnitOptions: { name: string, value: string }[] = [
    { name: 'email.email_template.trigger_offset_unit.minutes', value: 'minutes' },
    { name: 'email.email_template.trigger_offset_unit.hours', value: 'hours' },
    { name: 'email.email_template.trigger_offset_unit.days', value: 'days' },
];